import $ from 'jquery';
import get from 'lodash/get';

import './fields/validator';
import './fields/character-counter';
import './fields/radio-group-validator';
import './fields/floating-label-plugin';
import './fields/entry-error';

$(document).ready(() => {
  $(document.querySelectorAll('[data-validate]')).validator();
  $(document.getElementsByClassName('character-counter-field')).characterCounter();
  $(document.getElementsByClassName('character-counter-field-input')).characterCounter({
    fieldSelector: 'input',
  });
  $(document.getElementsByClassName('validate-radio-group')).radioGroupValidator({
    errorClassName: 'form-section__error',
  });

  $(document.querySelectorAll('[data-entry-error]')).entryError({
    requiredTemplate: get(window, 'rcProps.entryError.requiredTemplate', ''),
    invalidTemplate: get(window, 'rcProps.entryError.invalidTemplate', ''),
  });
  $(document.getElementsByClassName('floating-label')).floatingLabel();
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/elements.js